// extracted by mini-css-extract-plugin
export var divider = "_3y-0";
export var dividerText = "_3y-2";
export var dividerVertical = "_3y-1";